export default __webpack_public_path__ + "static/media/02.1fa105a5.jpg";